import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";

export const keyPlans: BaseKeyFunction = () => ["plans"];

export const keyGiftCards: BaseKeyFunction = () => ["gift-cards"];

export const keyPublicPlans: BaseKeyFunction = () => ["public-plans"];
